import ProtectedRoute from './ProtectedRoute';
import InternalProtectedRoute from './InternalProtectedRoute';

export default ProtectedRoute;
export { InternalProtectedRoute };